import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import {
  COMPANIES_LIST,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_LOGIN,
} from '@/common/constants';
import { useTagManager } from '@/common/contexts/TagManagerContext';
import { TAG_MANAGER } from '@/ebat/constants';

const useLogin = () => {
  const history = useHistory();
  const { onPushEvent } = useTagManager();

  const openModal = useCallback(() => history.push(ROUTE_FORGOT_PASSWORD), [
    history,
  ]);

  const closeModal = useCallback(() => history.push(ROUTE_LOGIN), [history]);

  /**
   * Push dataLayer
   * @type {function(): void}
   */
  const handlePushDataLayer = useCallback(
    (data) =>
      onPushEvent({
        company: COMPANIES_LIST[data?.attributes?.erp_company_code]?.name,
        customer_id: data?.attributes?.erp_customer_code,
        event: TAG_MANAGER.EVENTS.CTA_LOGIN,
      }),
    [onPushEvent],
  );

  return {
    openModal,
    closeModal,
    handlePushDataLayer,
  };
};

export default useLogin;
